import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { targetingVocabularyOptions } from '#leadOverviewFeature/models/targeting/queries';

/**
 * The contact roles with their German labels, as the backend vocabulary defines them
 * (GET /search/targeting/vocabulary → contactRoles). Until it has loaded, a role shows its key.
 * @returns {{
 *   roleLabel: (key: string|null|undefined) => string,
 *   enrichableRoles: Array<{key: string, label: string, description: string|null}>,
 *   priorityRoles: Array<{key: string, label: string, description: string|null}>,
 * }}
 */
export default function useContactRoles() {
	const { data } = useQuery(targetingVocabularyOptions());

	return useMemo(() => {
		const roles = data?.contactRoles ?? [];
		const labels = new Map(roles.map((role) => [role.key, role.label]));
		const enrichableRoles = roles.filter((role) => role.contactable);
		return {
			roleLabel: (key) => (key ? (labels.get(key) ?? key) : ''),
			enrichableRoles,
			// The recipient picker also offers the company itself as the last resort.
			priorityRoles: [...enrichableRoles, ...roles.filter((role) => role.key === 'company')],
		};
	}, [data]);
}
